import * as React from "react";
import { Textarea } from "@/dentlab/src/components/ui/textarea";
import { cn } from "@/dentlab/src/lib/util";
import {
	InputWrapper,
	INVALID_CONTROL_CLASS,
} from "@/dentlab/src/components/input-wrapper";

export type TextareaDensitySize = "sm" | "md" | "lg";

const TEXTAREA_MIN_HEIGHT: Record<TextareaDensitySize, string> = {
	sm: "min-h-[40px]",
	md: "min-h-[50px]",
	lg: "min-h-[60px]",
};

export interface CustomTextareaShadcnProps
	extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	validationError?: string | null;
	customHelperText?: string;
	name?: string;
	label?: string;
	required?: boolean;
	classNameTextarea?: string;
	classNameWrapper?: string;
	densitySize?: TextareaDensitySize;
	inputHeight?: number;
}

export const CustomTextareaShadcn = React.memo<CustomTextareaShadcnProps>(
	({
		validationError,
		customHelperText,
		value,
		onChange,
		label,
		required,
		classNameTextarea,
		classNameWrapper,
		densitySize,
		...rest
	}) => {
		return (
			<InputWrapper
				label={label}
				required={required}
				validationError={validationError}
				customHelperText={customHelperText}
				className={classNameWrapper}
			>
				<Textarea
					{...rest}
					className={cn(
						"w-full",
						densitySize
							? TEXTAREA_MIN_HEIGHT[densitySize]
							: "min-h-[60px]",
						densitySize === "sm" && "text-sm",
						validationError && INVALID_CONTROL_CLASS,
						classNameTextarea
					)}
					data-testid={`custom-textarea-${rest.name}`}
					value={value}
					onChange={onChange}
				/>
			</InputWrapper>
		);
	}
);
